"use client";

import { c as _c } from "react/compiler-runtime";
import cloudflareLoader from '@/lib/utils/cdn-cloudflare-loader';
import Image from 'next/image';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import BurstModeIcon from '@mui/icons-material/BurstMode';
export default function AlbumCard(t0) {
  const $ = _c(33);
  const {
    album
  } = t0;
  const params = useParams();
  const slug = params?.slug;
  const prevImages = album.previewGalleries;
  const location = album.location;
  const projectName = album.name;
  const totalGalleryCount = album.totalGalleryCount;
  const t1 = slug ? `/digital-profile/${slug}/${album.id}` : "#";
  let t2;
  if ($[0] !== prevImages[0]) {
    t2 = prevImages[0] ? <div className="relative min-w-0 flex-1"><Image src={cloudflareLoader({
        src: prevImages[0],
        width: 300,
        quality: 75
      })} alt="album_preview" className="object-cover" sizes="50vw" fill={true} unoptimized={true} /></div> : <div className="min-w-0 flex-1 bg-[--colorSecondarySecondaryContainer] " />;
    $[0] = prevImages[0];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== prevImages[1]) {
    t3 = prevImages[1] ? <div className="relative min-w-0 flex-1"><Image src={cloudflareLoader({
        src: prevImages[1],
        width: 300,
        quality: 75
      })} alt="album_preview" className="object-cover" sizes="50vw" fill={true} unoptimized={true} /></div> : <div className="min-w-0 flex-1 bg-[--colorOutlineOutlineVar]" />;
    $[2] = prevImages[1];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <div className="flex min-h-0 flex-1 gap-1">{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== prevImages[2]) {
    t5 = prevImages[2] ? <div className="relative min-h-0 flex-1"><Image src={cloudflareLoader({
        src: prevImages[2],
        width: 600,
        quality: 75
      })} alt="album_preview" className="object-cover" sizes="100vw" fill={true} unoptimized={true} /></div> : <div className="min-h-0 flex-1 bg-[--colorOutlineOutline] " />;
    $[7] = prevImages[2];
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== projectName) {
    t6 = <p className="text-white m3-title-medium truncate line-clamp-1 ">{projectName}</p>;
    $[9] = projectName;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <LocationOnOutlinedIcon htmlColor="white" sx={{
      fontSize: 16
    }} />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = location?.locality;
  const t9 = location?.city;
  let t10;
  if ($[12] !== t8 || $[13] !== t9) {
    t10 = <div className="flex items-center gap-1 text-white m3-label-medium">{t7}<p className="truncate max-w-[100px]">{t8}, {t9}</p></div>;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <BurstModeIcon htmlColor="white" sx={{
      fontSize: 16
    }} />;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== totalGalleryCount) {
    t12 = <div className="flex items-center gap-1 text-white m3-label-medium">{t11}<p className="m3-label-medium">{totalGalleryCount}</p></div>;
    $[16] = totalGalleryCount;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t10 || $[19] !== t12) {
    t13 = <div className="flex gap-2">{t10}{t12}</div>;
    $[18] = t10;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t13 || $[22] !== t6) {
    t14 = <div className=" flex flex-col  justify-end absolute bottom-0 left-0 w-full h-full bg-gradient-to-t from-[#1c1c1c] via-[#1c1c1c50] to-transparent p-2 ">{t6}{t13}</div>;
    $[21] = t13;
    $[22] = t6;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t14 || $[25] !== t5) {
    t15 = <div className="flex min-h-0 flex-1 gap-1 relative ">{t5}{t14}</div>;
    $[24] = t14;
    $[25] = t5;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t15 || $[28] !== t4) {
    t16 = <div className="flex h-full min-h-0 flex-1 flex-col gap-1 border-4 border-[--colorDisabledOnColorDisabled] rounded-xl overflow-hidden ">{t4}{t15}</div>;
    $[27] = t15;
    $[28] = t4;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t1 || $[31] !== t16) {
    t17 = <Link href={t1} className="flex w-full aspect-square flex-col overflow-hidden rounded-xl">{t16}</Link>;
    $[30] = t1;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  return t17;
}